import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_ANLEGEN_ADMIN = '[BenutzerverwaltungModul] PostBenutzerAnlegenAdmin laden';
export const POST_BENUTZER_ANLEGEN_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerAnlegenAdmin ausführen';
export const POST_BENUTZER_ANLEGEN_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerAnlegenAdmin laden erfolgreich';
export const POST_BENUTZER_ANLEGEN_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerAnlegenAdmin Ladefehler';
export const POST_BENUTZER_ANLEGEN_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerAnlegenAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerAnlegenAdminAction implements Action {
    readonly type = POST_BENUTZER_ANLEGEN_ADMIN;
        constructor(public benutzerAnlegenRequest: api.BenutzerAnlegenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerAnlegenAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_ANLEGEN_ADMIN_AUSFUEHREN;
        constructor(public benutzerAnlegenRequest: api.BenutzerAnlegenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerAnlegenAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_ANLEGEN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerAnlegenRequest: api.BenutzerAnlegenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerAnlegenAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_ANLEGEN_ADMIN_FEHLER;
        constructor(public payload: any, public benutzerAnlegenRequest: api.BenutzerAnlegenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerAnlegenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_ANLEGEN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerAnlegenAdminActions =
    PostBenutzerAnlegenAdminAction
    | PostBenutzerAnlegenAdminAusfuehrenAction
    | PostBenutzerAnlegenAdminErfolgreichAction
    | PostBenutzerAnlegenAdminFehlerAction
    | PostBenutzerAnlegenAdminNichtAusgefuehrtAction
    ;
